import { PPDropDown } from 'processor-plataform-ui';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Modal from '../../../../components/Dialog/Modal';
import LcLoading from '../../../../components/Generic/LcLoading';
import LCFlexContainer from '../../../../components/Layout/LCFlexContainer';
import LCFlexItem from '../../../../components/Layout/LCFlexItem';
import { PauseReason } from '../../../../models/PauseReason';
import { SolicitationView } from '../../../../models/SolicitationView';
import { WorkView } from '../../../../models/WorkView';
import PauseReasonService from '../../../../services/PauseReasonService/PauseReasonService';
import WorkService from '../../../../services/WorkService/WorkService';
import { RootState } from '../../../../store';
import { UserState } from '../../../../store/reducers/userReducer';

interface PropsWorkList {
    work: WorkView;
    solicitation: SolicitationView;
    onCloseEvent: Function;
    open: boolean;

    content: string;
    confirmMessage: string;
    idConfirm?: string;
    abortMessage: string;
    idAbort?: string;
}
export interface Validate {
    name: string;
    validateMessage: string;
    valid: boolean;
}
interface Option {
    label: string;
    value: string;
}

const PauseWork: React.FC<PropsWorkList> = (props) => {
    const user = useSelector<RootState, UserState>(state => state.user);
    const [workService, setWorkService] = useState<WorkService>(new WorkService(props));
    const [pauseReasonService, setPauseReasonService] = useState<PauseReasonService>(new PauseReasonService(props));
    const [optionsPauseReason, setOptionsPauseReason] = useState<Option[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [work, setWork] = useState<WorkView>(props.work);

    async function retrievePauseReason() {
        setLoading(true);

        try {
            var listWorkTeams = await pauseReasonService.getPauseReasons(props.solicitation.idBusinessArea as number);
            var optionsTArray = listWorkTeams.map((item: PauseReason) => {
                return {
                    label: item.description,
                    value: item.id.toString()
                } as Option;
            }).sort((a: any, b: any) => a.label > b.label ? 1 : -1);

            setOptionsPauseReason(optionsTArray);
        } catch (e) {

        }

        setLoading(false);
    }

    useEffect(() => {
        setOptionsPauseReason([]);
        setValidations([]);
        setWork({
            ...props.work,
            idPauseJustification: 0
        });

        retrievePauseReason();
    }, []);

    async function changeData(event: any) {
        const { name, value } = event.target;
        setWork({ ...work, [name]: value })
    };

    async function Save() {
        setLoading(true);

        if (validateRules() == false) {
            setLoading(false);
            return true;
        }

        try {
            var workToSave = {
                ...work,
                idUser: user.id as number,
                idStatus: 5,
            };

            await workService.updateWork(workToSave);
            setLoading(false);
            if (props.onCloseEvent != null) {
                props.onCloseEvent(true);
            }
        } catch (e) {
            debugger;
        }

        setLoading(false);
    }

    const [validations, setValidations] = useState<Validate[]>([]);

    const validateRules = () => {
        var validationsChecks: Validate[] = [];

        if (!(work.idPauseJustification > 0)) {
            validationsChecks.push({
                name: 'idPauseJustification',
                validateMessage: 'Deve possuir razão de pausa preenchido.',
                valid: false
            });
        }

        if (validationsChecks.length != 0) {
            setValidations(validationsChecks);
        }

        return validationsChecks.length === 0;
    }

    return (
        <Modal title={'Pausar trabalho'} visible={props.open} close={() => { if (props.onCloseEvent != null) props.onCloseEvent(false); }}>
            <LcLoading loading={loading} label={"Carregando..."}>
                <LCFlexContainer spacing={2}>
                    <LCFlexItem xs={12} sm={12} md={12} lg={12}>
                        <PPDropDown
                            required
                            name={'idPauseJustification'}
                            options={optionsPauseReason}
                            title={'Motivo de pausa'}
                            placeholderSearch={'Buscar motivo'}
                            onChange={changeData}
                            value={work.idPauseJustification != null ? work.idPauseJustification.toString() : '0'}
                            error={{
                                show: validations.find(x => 'idPauseJustification' === x.name) !== undefined,
                                help: `${validations.find(x => 'idPauseJustification' === x.name)?.validateMessage}`
                            }}
                        />
                    </LCFlexItem>
                    <LCFlexItem xs={12} sm={12} md={12} lg={12}>
                        <div className={"row"}>
                            <button
                                style={{ margin: '10px' }}
                                className={'lc-button bg-info'}
                                id={'Ok'}
                                onClick={() => Save()}
                                color={"primary"}>
                                Ok
                            </button>
                            <button
                                className={'lc-button bg-info'}
                                id={'Cancelar'}
                                onClick={() => {
                                    if (props.onCloseEvent != null) {
                                        props.onCloseEvent(false);
                                    }
                                }}
                                color={"primary"}>
                                Cancelar
                            </button>
                        </div>
                    </LCFlexItem>
                </LCFlexContainer>
            </LcLoading>
        </Modal>
    );
};

export default PauseWork;